import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import api, { API, apiErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader } from "@/components/Common";
import { toast } from "sonner";
import { Heart } from "lucide-react";

export default function JoinInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const { user, register, login, loadMe, refreshWedding } = useAuth();
  const [inv, setInv] = useState(null);
  const [mode, setMode] = useState("register");
  const [f, setF] = useState({ first_name: "", last_name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    axios.get(`${API}/invitations/${token}`).then(({ data }) => {
      setInv(data); setF((p) => ({ ...p, email: data.email }));
    }).catch(() => setInv(false));
  }, [token]);

  const accept = async () => {
    const { data } = await api.post(`/invitations/${token}/accept`);
    await loadMe(); refreshWedding();
    toast.success("Vous avez rejoint l'espace !");
    nav("/app");
  };

  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try {
      if (user) { await accept(); return; }
      if (mode === "register") await register(f);
      else await login(f.email, f.password);
      await accept();
    } catch (err) { toast.error(apiErr(err.response?.data?.detail)); setLoading(false); }
  };

  if (inv === null) return <div className="min-h-screen bg-background"><Loader /></div>;
  if (inv === false) return (
    <div className="min-h-screen flex items-center justify-center bg-background text-center">
      <div><h1 className="font-serif text-2xl">Invitation invalide</h1>
        <p className="text-stone-500 mt-2">Ce lien n'est plus valide.</p>
        <Link to="/"><Button variant="outline" className="mt-4 rounded-full">Accueil</Button></Link></div></div>
  );

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <div className="card-lux p-8 max-w-md w-full animate-fade-up">
        <div className="w-12 h-12 rounded-2xl bg-accent flex items-center justify-center mb-5">
          <Heart className="w-5 h-5 text-stone-800" /></div>
        <h1 className="font-serif text-2xl">Vous êtes invité·e</h1>
        <p className="text-stone-600 mt-2">Rejoignez l'espace de planification du mariage
          <b> {inv.wedding_names}</b> en tant que <b>{inv.role === "COUPLE_PARTNER" ? "partenaire" : "collaborateur·rice"}</b>.</p>

        {user ? (
          <Button onClick={submit} disabled={loading} className="w-full h-11 rounded-full mt-6">
            Rejoindre l'espace</Button>
        ) : (
          <form onSubmit={submit} className="space-y-3 mt-6">
            {mode === "register" && (
              <div className="grid grid-cols-2 gap-3">
                <div><Label>Prénom</Label><Input value={f.first_name} onChange={(e) => setF({ ...f, first_name: e.target.value })} required className="mt-1 h-11" /></div>
                <div><Label>Nom</Label><Input value={f.last_name} onChange={(e) => setF({ ...f, last_name: e.target.value })} className="mt-1 h-11" /></div>
              </div>
            )}
            <div><Label>E-mail</Label><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} required className="mt-1 h-11" /></div>
            <div><Label>Mot de passe</Label><Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required className="mt-1 h-11" /></div>
            <Button disabled={loading} className="w-full h-11 rounded-full">
              {loading ? "…" : mode === "register" ? "Créer mon compte et rejoindre" : "Se connecter et rejoindre"}</Button>
            <button type="button" onClick={() => setMode(mode === "register" ? "login" : "register")}
              className="text-sm text-champagne w-full text-center">
              {mode === "register" ? "J'ai déjà un compte" : "Créer un compte"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
